import { render } from "./AboutUs.vue?vue&type=template&id=b61fd1f8&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=b61fd1f8&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61fd1f8"]])

export default __exports__